<template>
    <div class="am-add-task">
        <div class="am-task-title-bar am-main-top-box">
            <span class="am-task-title am-main-top-box-title"><strong>{{ title }}:</strong></span>
        </div>
        <form class="am-task-form">
            <div>
                <table class="am-task-edit-results am-task-table am-width100percent">
                    <tbody>
                    <tr>
                        <td colspan="2">
                          <strong><span class="am-task-problue">Task Details:</span></strong>
                          <div class="am-blue-border"></div>
                        </td>
                    </tr>
                    <tr>
                        <td class="am-width50percent">
                          <strong>Type of Task:</strong>
                        </td>
                        <td class="am-width50percent">
                          <select class="am-dropdown-width" name="type" v-model="taskCopy.type" @change="checkShowInCalendar" :disabled="!isEdit">
                            <option value='0' >- Select Task Type -</option>
                            <option v-for="type in types" :value="type.value" :key="type.value">{{ type.description }}</option>
                          </select>
                        </td>
                    </tr>
                    <tr>
                        <td class="am-width50percent">
                          <strong>Review Required:</strong>
                        </td>
                        <td>
                          <input class='am-med-checkbox' name="review_required" type="checkbox" v-model="taskCopy.review_required" :true-value="1" :false-value="0" :disabled="!isEdit"/>
                        </td>
                    </tr>
                    <tr v-bind:class="{ 'am-h-26': customerId }">
                        <td><strong><span>Customer Number</span>:</strong></td>
                        <td>
                          <input type="text" class="input" name="custid" v-if="!customerId" v-on:change="clearLeadNumber($event)"  v-on:blur="getCustomerName()" v-model="taskCopy.custid" :disabled="!isEdit">
                          <span class="gray" v-if="customerId"><b>{{ customerId }}</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong> {{customerNameLabel}} </strong>
                        </td>
                        <td class="gray">
                            {{customerName}}
                        </td>
                    </tr>
                    <tr v-if="$store.state.auth.config.isReceiveLeads && !customerId">
                      <td><strong><span>Lead Number</span>:</strong></td>
                      <td><input type="text" class="input" name="leadMainId" v-on:change="clearCustomerNumber($event)"  v-on:blur="getLeadMainName()" v-model="taskCopy.leadMainId" :disabled="!isEdit"></td>
                    </tr>
                    <tr>
                        <td>
                           <strong> {{leadNameLabel}} </strong>
                        </td>
                        <td class="gray">
                            {{leadName}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>To:</strong>
                        </td>
                        <td>
                            <select class="am-dropdown-width" name="touser" v-model="taskCopy.touser" :disabled="!isEdit">
                              <option value='0' >- Select To User -</option>
                              <option v-for="user in users" :value="user.value" :key="user.value">{{user.description}}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Created By:</strong>
                        </td>
                        <td class="gray">
                            {{fromUserLabel}}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Due Date:</strong></td>
                        <td><input type="date" name="duedate" v-model="taskCopy.duedate" :disabled="!isEdit"></td>
                    </tr>
                    <tr>
                        <td><strong>Task Time:</strong></td>
                        <td><select type="text" name="tasktime" v-model="taskCopy.tasktime" :disabled="!isEdit">
                            <option value="00:00">12:00 AM</option>
                            <option value="00:30">12:30 AM</option>
                            <option value="01:00">01:00 AM</option>
                            <option value="01:30">01:30 AM</option>
                            <option value="02:00">02:00 AM</option>
                            <option value="02:30">02:30 AM</option>
                            <option value="03:00">03:00 AM</option>
                            <option value="03:30">03:30 AM</option>
                            <option value="04:00">04:00 AM</option>
                            <option value="04:30">04:30 AM</option>
                            <option value="05:00">05:00 AM</option>
                            <option value="05:30">05:30 AM</option>
                            <option value="06:00">06:00 AM</option>
                            <option value="06:30">06:30 AM</option>
                            <option value="07:00">07:00 AM</option>
                            <option value="07:30">07:30 AM</option>
                            <option value="08:00">08:00 AM</option>
                            <option value="08:30">08:30 AM</option>
                            <option value="09:00">09:00 AM</option>
                            <option value="09:30">09:30 AM</option>
                            <option value="10:00">10:00 AM</option>
                            <option value="10:30">10:30 AM</option>
                            <option value="11:00">11:00 AM</option>
                            <option value="11:30">11:30 AM</option>
                            <option value="12:00">12:00 PM</option>
                            <option value="12:30">12:30 PM</option>
                            <option value="13:00">01:00 PM</option>
                            <option value="13:30">01:30 PM</option>
                            <option value="14:00">02:00 PM</option>
                            <option value="14:30">02:30 PM</option>
                            <option value="15:00">03:00 PM</option>
                            <option value="15:30">03:30 PM</option>
                            <option value="16:00">04:00 PM</option>
                            <option value="16:30">04:30 PM</option>
                            <option value="17:00">05:00 PM</option>
                            <option value="17:30">05:30 PM</option>
                            <option value="18:00">06:00 PM</option>
                            <option value="18:30">06:30 PM</option>
                            <option value="19:00" >07:00 PM</option>
                            <option value="19:30">07:30 PM</option>
                            <option value="20:00">08:00 PM</option>
                            <option value="20:30">08:30 PM</option>
                            <option value="21:00">09:00 PM</option>
                            <option value="21:30">09:30 PM</option>
                            <option value="22:00">10:00 PM</option>
                            <option value="22:30">10:30 PM</option>
                            <option value="23:00">11:00 PM</option>
                            <option value="23:30">11:30 PM</option>
                        </select>
                        </td>
                    </tr>
                    <tr v-if="showDuration">
                      <td><strong>Duration:</strong></td>
                      <td>
                        <input type="range" min="15" max="480" step="15" class="am-task-slider" name="duration" v-model="duration" :disabled="!isEdit">
                      </td>
                    </tr>
                    <tr v-if="showDuration">
                      <td></td>
                      <td>
                        <span>{{ durationDisplay }}</span>
                      </td>
                    </tr>
                    <tr>
                        <td><strong>Priority:</strong></td>
                        <td>
                            <select class="am-dropdown-width" name="priority" v-model="taskCopy.priority" :disabled="!isEdit">
                              <option value='0' >- Select Priority -</option>
                              <option v-for="priority in priorities" :value="priority.value" :key="priority.value">{{priority.description}}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Status:</strong></td>
                        <td>
                            <select class="am-dropdown-width" name="taskstatusid" v-model="taskCopy.taskstatusid" :disabled="!isEdit">
                              <option value='0' >- Select Status -</option>
                              <option v-for="status in statusID" :value="status.value" :key="status.value">{{status.description}}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <strong><span>Task Description:</span></strong>
                        <speech-to-text-button :text-area="$refs.taskDesc" :disabled="disableDescMic || !isEdit || !hasBackOfficeAddons(49)" :force-stop="stopAllRecording" @startRecording="descRecording" @stopRecording="stopRecording"></speech-to-text-button>
                        <span class="am-task-countdown">Characters Remaining: {{ remainingCount }} of 1000</span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                          <textarea ref="taskDesc" :maxlength="getMaxLength(taskCopy)" class="am-width100percent" name="desc" rows="4" v-model="taskCopy.desc" :disabled="!isEdit"></textarea>
                      </td>
                    </tr>
                    <tr v-if="showTaskNote">
                      <td colspan="2">
                        <strong><span class="am-task-problue">Task Notes:</span></strong>
                        <div class="am-blue-border"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button class="am-bm-5" type="button" v-if="!showTaskNote" @click="displayTaskNote()" :disabled="!isEdit">Add Note</button>
                        <strong v-if="showTaskNote"><span>Note Description:</span></strong>
                        <speech-to-text-button v-if="showTaskNote" :text-area="$refs.taskNotes" :force-stop="stopAllRecording" :disabled="disableNotesMic || !hasBackOfficeAddons(49)" @startRecording="notesRecording" @stopRecording="stopRecording"></speech-to-text-button>
                      </td>
                      <td>
                      </td>
                    </tr>
                    <tr v-if="showTaskNote">
                      <td colspan="2">
                        <textarea ref="taskNotes" class="am-width100percent" name="notes" rows="4" v-model="taskCopy.notes"></textarea>
                      </td>
                    </tr>
                    </tbody>
                </table>
            </div>

          <div class="am-note-list" v-show="notes.length">
            <table class="am-notes-table am-width100percent">
              <thead>
                <tr>
                  <th class="am-width5percent"><strong></strong></th>
                  <th class="am-width30percent"><strong>Previous Notes:</strong></th>
                  <th class="am-width30percent"><strong>User</strong></th>
                  <th class="am-width30percent"><strong>Date</strong></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="note in notes" :key="note.id">
                    <td>
                      <a @click="copyClipboardNote(note)">
                        <svg-icon class="am-glyphicon-medium am-glyphicon-blue" icon="copy" title="Click to copy the note"></svg-icon>
                      </a>
                    </td>
                  <td>
                    <div class="am-notes-tooltip">
                      <span>{{truncateNoteMessage(note.text)}}<span>{{note.text}}</span></span>
                    </div>
                  </td>
                  <td>{{note.userName}}</td>
                  <td>{{note.trandate | moment("MM/DD/YYYY HH:mm:ss")}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-right am-mt-10" v-show="notes.length">
            <pagination :allData="allNotes" :pageSize="4" :simpleMode="true" @setPageData="setPageData"></pagination>
          </div>
          <div class="am-blue-border" v-bind:class="{ 'am-mt-15': !notes.length }"></div>
          <div class="am-align-bottom-buttons">
            <div class="am-float-left">
              <button type="button" @click="saveAction" v-show="isEdit">Save</button>
              <button type="button" v-if="taskCopy.open" @click="saveAndCloseAction" v-show="isEdit">Save & Close</button>
              <button type="button" v-if="!taskCopy.open" @click="reopenTask">Reopen</button>
              <button type="button" v-if="title === 'Edit Task'" @click="hideTask" v-show="isEdit">Hide</button>
            </div>
            <div class="am-float-right">
              <button type="button" @click="closeModal">Cancel</button>
            </div>
          </div>
        </form>
      <modal name="Alert" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3" height="180px" width="400px">
        <alert  :message="messageString" @closeAction="closeHideModal"></alert>
      </modal>
    </div>
</template>

<script>

import api from './../http'
import Headerbar from './Headerbar'
import pagination from '@/components/pagination/pagination.vue'
import speechToTextButton from '@/components/SpeechToTextButton.vue'
import helper from '@/mixins/helper'
import Alert from "./Alert";
export default {

  name: 'TaskEdit',

  components: {
    Alert,
    pagination,
    Headerbar,
    speechToTextButton
  },

  mixins: [helper],

  data: function () {
    return {
      name: 'task',
      messageString:'',
      types: [],
      users: [],
      priorities: [],
      statusID: [],
      notes: [],
      fromUserLabel: '',
      isHidden: false,
      blankTask: {
        id: 0,
        active: 1,
        open: 1,
        type: 0,
        review_required: 0,
        custid: '',
        leadMainId: '',
        office: 0,
        touser: 0,
        fromuser: 0,
        duedate: 'mm/dd/yyyy',
        tasktime: '',
        duration: 15,
        priority: 0,
        taskstatusid: 0,
        desc: '',
        notes: '',
        currentUser: 0
      },
      customerName: '',
      leadName: '',
      showTaskNote: false,
      showDuration: false,
      duration: 15,
      taskCopy: {
        desc: ''
      },
      disableDescMic: false,
      disableNotesMic: false,
      stopAllRecording: false,
      maxCount: 1000,
      hasError: false
    }
  },

  computed: {
    title () {
      let taskHeader = !this.isEdit ? 'View Task' : 'Edit Task'
      taskHeader = (this.getEditRowId() === 0) ? 'Add Task' : taskHeader
      return taskHeader
    },
    durationDisplay () {
      let hours = Math.floor(this.duration / 60)
      let minutes = this.duration % 60
      return (hours ? hours + (hours > 1 ? ' Hours ' : ' Hour ') : '') + (minutes ? minutes + ' Minutes' : '')
    },
    customerNameLabel () {
      return (this.customerName) ? 'Customer Name: ' : ''
    },

    leadNameLabel () {
      return (this.leadName) ? 'Lead Name: ' : ''
    },

    remainingCount: function () {
      if ((typeof this.taskCopy.desc) === 'undefined') {
        return this.maxCount
      }
      return this.maxCount - this.taskCopy.desc.length
    }
  },

  asyncComputed: {
    task: {
      get () {
        console.log('vueTaskEdit', this.editRow)
        if ((typeof this.editRow) === 'object') {
          var editTask = this.editRow
          return new Promise(function (resolve) {
            resolve(editTask)
          })
        } else if (this.getEditRowId() === 0) {
          var blankTask = this.blankTask
          return new Promise(function (resolve) {
            resolve(blankTask)
          })
        } else {
          return api.makeRequest('tasks/' + this.editRow).then(
            (data) => {
              return data.data.task
            }
          )
        }
      },
      default: {
        id: 0,
        active: 1,
        open: 1,
        type: 0,
        review_required: 0,
        custid: '',
        leadMainId: '',
        office: 0,
        touser: 0,
        fromuser: 0,
        duedate: 'mm/dd/yyyy',
        tasktime: '',
        duration: 15,
        priority: 0,
        taskstatusid: 0,
        desc: '',
        notes: '',
        currentUser: 0
      }
    },
    types: {
      get () {
        return api.makeRequest('tasks/types').then(
          (data) => {
            return data.data
          }
        )
      }
    },
    users: {
      get () {
        return api.makeRequest('tasks/users').then(
          (data) => {
            return data.data
          }
        )
      }
    },
    priorities: {
      get () {
        return api.makeRequest('tasks/priorities').then(
          (data) => {
            if (this.getEditRowId() === 0) {
              let defaultPriority = data.data.find(i => i.default)
              this.taskCopy.priority = defaultPriority ? defaultPriority.value : 0
            }
            return data.data
          }
        )
      }
    },
    statusID: {
      get () {
        return api.makeRequest('tasks/status').then(
          (data) => {
            if (this.getEditRowId() === 0) {
              let defaultStatus = data.data.find(i => i.default)
              this.taskCopy.taskstatusid = defaultStatus ? defaultStatus.value : 0
            }
            return data.data
          }
        )
      }
    },
    allNotes: {
      get () {
        return api.makeRequest('tasks/notes/' + this.getEditRowId()).then(
          (data) => {
            if (typeof data.data.message !== 'undefined' || data.data.length === 0) {
              return []
            }
            return data.data
          }
        )
      },
      default: []
    }
  },

  props: {
    isEdit: Boolean,
    editRow: Object,
    customerId: {
      type: [Number, String],
      default: 0
    },
    leadId: {
      type: [Number, String],
      default: 0
    }
  },

  methods: {
    async closeModal () {
      this.stopAllRecording = true
      if (await this.nothingRecording) {
        this.$store.dispatch('events/fireEvent', { name: 'task-close', data: null })
        this.$emit('closeEditModal')
        this.$emit('refreshList')
      }
    },

    setPageData (data) {
      this.notes = data
    },

    saveAction () {
      this.save()
    },

    saveAndCloseAction () {
      this.taskCopy.closedby = this.$store.state.auth.user.id
      this.save('close')
    },

    save (extraUrl = false) {
      this.updateTextArea()
      let self = this
      let data = Object.assign({}, this.taskCopy)

      if (data.touser < 0) {
        data.office = Math.abs(data.touser)
        data.touser = 0
      }

      if (this.showDuration) {
        data.duration = this.duration
      }

      // empty strings become null during backend and break
      if (data.desc === '') {
        delete data.desc
      }

      if (data.notes === '') {
        delete data.notes
      }

      if (data.duedate === '') {
        delete data.duedate
      }

      if (data.tasktime === '') {
        delete data.tasktime
      }

      if (data.leadMainId === '') {
        delete data.leadMainId
      }

      if (data.custid === '') {
        delete data.custid
      }

      api.postRequest('tasks/' + this.getEditRowId() + (extraUrl ? '/' + extraUrl : ''),
        data
      ).then(function (response) {
        console.log(response)
        self.closeModal()
        self.$store.dispatch('events/fireEvent', { name: 'refresh-page', data: null })
      }).catch(function (error) {
        let errorFields = Object.keys(error.response.data['Improperly formatted request'])

        for (let i = 0; i < errorFields.length; i++) {
          if (errorFields[i] === 'desc') {
            errorFields[i] = 'description'
          } else if (errorFields[i] === 'duedate') {
            errorFields[i] = 'due date'
          } else if (errorFields[i] === 'custid') {
            errorFields[i] = 'not a valid customer number'
          }
          errorFields[i] = self.toTitleCase(errorFields[i])
        }
        self.messageString = 'Fields that are improperly formatted or required: <br/>' + errorFields.join("<br/>")
        self.$modal.show('Alert')
      })
    },
    closeHideModal(){
        this.$modal.hide('Alert')
    },


    reopenTask () {
      this.save('reopen')
    },

    hideTask () {
      this.save('hide')
    },

    getEditRowId () {
      if ((typeof this.editRow) === 'object') {
        return this.editRow.id
      } else if ((typeof this.editRow) === 'undefined') {
        this.editRow = 0
      }

      return this.editRow
    },

    displayTaskNote () {
      this.showTaskNote = true
      this.extendModal()
    },

    truncateNoteMessage (message) {
      return message.substring(0, 15)
    },

    clearLeadNumber (event) {
      if (this.onlyNumeric(event)) {
        this.taskCopy.leadMainId = ''
        this.leadName = ''
        this.$forceUpdate()
      }
    },

    clearCustomerNumber (event) {
      if (this.onlyNumeric(event)) {
        this.taskCopy.custid = ''
        this.customerName = ''
        this.$forceUpdate()
      }
    },

    getCustomerName () {
      let id = (this.taskCopy.custid) ? this.taskCopy.custid : 0
      let self = this
      api.makeRequest('customer/' + id + '/name/').then(
        (data) => {
          self.customerName = (data.data.name) ? (data.data.name) : ''
          self.extendModal()
        }
      )
    },

    getLeadMainName () {
      let id = (this.taskCopy.leadMainId) ? this.taskCopy.leadMainId : 0
      let self = this
      api.makeRequest('lead/' + id + '/name/').then(
        (data) => {
          self.leadName = (data.data.name) ? (data.data.name) : ''
        }
      )
    },

    onlyNumeric (event) {
      event = (event) || window.event
      var charCode = (event.which) ? event.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault()
      } else {
        return true
      }
    },

    updateTextArea () {
      this.taskCopy.desc = this.$refs.taskDesc.value
      if (typeof this.$refs.taskNotes !== 'undefined') {
        this.taskCopy.notes = this.$refs.taskNotes.value
      }
      this.$forceUpdate()
    },

    descRecording () {
      this.disableNotesMic = true
    },

    notesRecording () {
      this.disableDescMic = true
    },

    stopRecording () {
      this.updateTextArea()
      this.disableNotesMic = false
      this.disableDescMic = false
    },

    nothingRecording () {
      let self = this
      return new Promise(resolve => {
        if (self.disableDescMic === false && self.disableNotesMic === false) {
          resolve(true)
        }
      })
    },

    checkShowInCalendar () {
      let currentTaskType = this.types.find(i => i.value === this.taskCopy.type)
      this.showDuration = currentTaskType ? currentTaskType.showInCalendar === 1 : false
      this.extendModal()
    },

    copyClipboardNote: function (note) {
      this.$copyText(note.text).then(function () {
        alert('Copied')
      }, function () {
        alert('Can not copy')
      })
    },

    extendModal () {
      let extraHeight = 40
      let extraTop = 0

      if (this.showTaskNote) {
        extraHeight += 100
        extraTop += 50
      }

      if (this.showDuration) {
        extraHeight += 40
        extraTop += 20
      }

      if (this.allNotes.length) {
        extraHeight += 120
        extraTop += 60
      }
      let self = this
      setTimeout(function () {
        self.$emit('extendModal', { height: extraHeight, top: extraTop })
      }, 0.1)
    },
    getMaxLength: function (task) {
      if (typeof task.desc !== 'undefined') {
        if (task.desc.length > 1000) {
          return false
        } else {
          return 1000
        }
      } else {
        return 1000
      }
    },

    toTitleCase (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
    }

  },

  watch: {
    'task': {
      handler: function () {
        this.taskCopy.id = this.task.id
        this.taskCopy.active = this.task.active
        this.taskCopy.open = this.task.open
        this.taskCopy.type = this.task.type
        this.taskCopy.review_required = this.task.review_required
        this.taskCopy.custid = this.task.id > 0 ? (this.task.custid > 0 ? this.task.custid : '') : (this.customerId > 0 ? this.customerId : '')
        this.taskCopy.leadMainId = this.task.id > 0 ? (this.task.leadMainId > 0 ? this.task.leadMainId : '') : (this.leadId > 0 ? this.leadId : '')
        this.getCustomerName()
        this.getLeadMainName()
        this.taskCopy.office = this.task.office
        this.taskCopy.touser = this.task.id > 0 ? (this.task.touser === 0 && this.taskCopy.office > 0 ? -this.taskCopy.office : this.task.touser) : this.$store.state.auth.user.id
        this.taskCopy.fromuser = this.task.fromuser ? this.task.fromuser : this.$store.state.auth.user.id
        this.fromUserLabel = this.task.id > 0 ? this.task.fromUser : this.$store.state.auth.user.name
        this.taskCopy.duedate = this.task.duedate
        this.taskCopy.tasktime = this.task.tasktime
        this.duration = this.task.duration > 0 ? this.task.duration : 15
        this.taskCopy.priority = this.task.priority
        this.taskCopy.taskstatusid = this.task.taskstatusid
        this.taskCopy.desc = this.task.desc ? this.task.desc : ''
        this.taskCopy.notes = ''
        this.taskCopy.currentUser = this.$store.state.auth.user.id

        if (typeof this.taskCopy.tasktime !== 'undefined') {
          var taskTime = this.taskCopy.tasktime.split(':')
          taskTime.pop()
          this.taskCopy.tasktime = taskTime.join(':')
        }
      }
    },
    'types': {
      handler: function () {
        this.checkShowInCalendar()
      }
    },
    'allNotes': {
      handler: function () {
        this.extendModal()
      }
    }
  }
}
</script>

<style scoped>

  .am-notes-table {
    font-size: 11px;
    line-height: 18px;
    margin-top: 10px;
  }

  .am-note-list {
    height: 100px;
  }

  .am-med-checkbox {
    height: 18px;
    width: 18px;
  }

  .am-task-slider {
      -webkit-appearance: none;
      width: 100%;
      height: 7px;
      background: white;
      border: 1px solid #4297d7;
      border-radius: 10px;
      outline: none;
      opacity: 0.7;
      -webkit-transition: .2s;
      transition: opacity .2s;
  }

  .am-task-slider:hover {
      opacity: 1;
  }

  .am-task-slider::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 12px;
      height: 12px;
      background: #4297d7;
      border-radius: 14px;
      cursor: pointer;
  }

  .am-task-slider::-webkit-slider-thumb:hover {
      background: #87bb00;
  }

  .am-add-task {
      width: 100%;
      display: block;
      background-color: #fcfdfd;
      margin: 0;
      position: absolute;
  }

  .am-task-title-bar {
      display: block;
      height: 35px;
      width: auto;
      border-radius: 1px;
  }

  .am-task-title {
      font-size: 14px;
      color: #FDFEFE;
      float: left;
      margin-top: 5px;
      margin-left: 10px;

  }

  .am-task-table {
    line-height: 18px;
  }

  .am-task-edit-results input, select, textarea{
    background-color: #ffffef;
    resize: none;
  }

  .am-task-form {
    font-size: 11px;
    margin: 7px 20px;
    overflow: auto;
  }

  input {
      width: 100%;
  }

  select {
      width: 100%;
  }

  .am-h-26 {
    height: 26px;
  }

  .am-task-problue {
      color: #4297d7;
  }

  .am-align-bottom-buttons {
    display: block;
    margin: auto;
  }

  .am-align-bottom-buttons button{
    margin: 3px;
  }

  .am-float-left{
    float: left;
  }

  .am-float-right{
    float: right;
  }

  .am-bm-5{
    margin-bottom: 5px;
  }

  .am-mt-10{
    margin-top: 10px;
  }

  .am-mt-15{
    margin-top: 15px;
  }

  .am-blue-border {
      display: block;
      width: 100%;
      border-top: 1px solid #4297d7;
      margin-bottom: 10px;
  }

  .am-grey-border {
    display: block;
    width: 100%;
    border-top: 1px solid #bbbfd7;
    margin-bottom: 10px;
  }

  .am-task-icon-button {
      margin-top: 20px;
      font-size: 11px;
      margin-right: 88px;
      float: right;
  }

  .am-task-icon-button span {
      padding: 18px 4px 18px;
  }

  .am-task-countdown {
    float: right;
    padding-top: 5px;
    font-size: 9px;
  }

  .am-task-links  {
      float: right;
      color: #0059b3;
      margin-right: 5px;
  }

  .am-width100percent {
    width: 100%;
  }

  .am-width50percent {
    width: 50%;
  }

  .am-width30percent {
    width: 30%;
  }

  .am-width20percent {
    width: 20%;
  }

  .am-width5percent {
    width: 5%;
  }

  li {
    height: 50px;
  }

  .am-notes-tooltip {
    cursor: default;
  }

  .am-notes-tooltip span{
    color: #0059b3;
    position: relative;
    font-size: 11px;
  }

  .am-notes-tooltip span span{
    display:none;
    position: relative;
    overflow-wrap: break-word;
    width: 275px;
  }

  .am-notes-tooltip span:hover span {
    position: absolute;
    z-index: 9999999;
    left: 50px;
    top: 200%;
    display: block;
    background: #ffffef;
    color: black;
    transform: translate(0, -100%);
    border: 1px solid #a0a2a5;
    max-width: 275px;
    max-height: 350px;
    box-shadow: 3px 3px 3px#888888;
    padding: 10px 10px 10px 10px;
    overflow: auto;
  }

</style>
